import styled from 'styled-components';

export const FlowNameItem = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f3f3;
  }
`;

export const FlowHeader = styled.div`
  padding: 8px 8px 4px;
  font-weight: 500;
`;

export const FlowContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlowContent = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;
